import React, { useContext, useEffect, useState } from 'react'
import {
  CButton,
  CFormSwitch,
  CModal,
  CModalBody,
  CModalFooter,
  CTable,
  CTableRow,
  CTableBody,
  CTableDataCell,
  CModalHeader,
} from '@coreui/react'
import { GlobalContext } from 'src/views/context/GlobalState'
import { getThumbnail } from 'src/views/utils/helper'
import ReactDragListView from 'react-drag-listview/lib/index.js'
import { isEmpty } from 'lodash'
import PlusIcon from '../../../assets/plus-icon.svg'
import EditIcon from '../../../assets/edit-icon.svg'
import TrashIcon from '../../../assets/trash-icon.svg'
import SixDots from '../../../assets/six-dots.svg'
import CopyLight from '../../../assets/copy-light.svg'
// import RosemaryCarouselCardModal from './rosemaryCarouselCardModal'
import DeleteModal from 'src/components/DeleteModal/DeleteModal'
import DefaultBannerCardModal from './defaultBannerCardModal'

const DefaultBannerModal = ({ componentData, modifyData, modalSpecificData, onCancel }) => {
  const { userSessionObj } = useContext(GlobalContext)

  const [autoSlide, setAutoSlide] = useState()
  const [cardModal, setCardModal] = useState(false)
  const [deleteModal, setDeleteModal] = useState(false)
  const [selectedCardIndex, setSelectedCardIndex] = useState('')
  const [singleSlideData, setSingleSlideData] = useState({})
  const [editCardIndex, setEditCardIndex] = useState()
  const [isEdit, setIsEdit] = useState(false)
  const [slidesData, setSlidesData] = useState([])

  useEffect(() => {
    if (!isEmpty(componentData?.data?.slide_data)) {
      setSlidesData(componentData?.data?.slide_data)
      setAutoSlide(componentData?.data?.auto_slide)
    }
  }, [])

  const copyCard = (idx) => {
    let tempslidesDataArr = slidesData
    let copyObj = slidesData[idx]
    tempslidesDataArr.splice(idx + 1, 0, copyObj)
    setSlidesData([...tempslidesDataArr])
  }
  /* delete card code */
  const deleteCard = (index) => {
    setSelectedCardIndex(index)
    setDeleteModal(true)
  }

  const onDeleteCard = (index) => {
    setSlidesData((prevData) => prevData.filter((data, idx) => idx !== index))
    setDeleteModal(false)
    setSelectedCardIndex('')
  }

  const handleSave = () => {
    let elementObj = {
      auto_slide: autoSlide,
      slide_data: slidesData,
    }

    modifyData(componentData.id, elementObj)
  }

  const dragProps = {
    onDragEnd(fromIndex, toIndex) {
      const data = [...slidesData]
      const item = data.splice(fromIndex, 1)[0]
      data.splice(toIndex, 0, item)
      setSlidesData([...data])
    },
    handleSelector: '',
  }

  /* Add card code */
  const addNewCard = () => {
    setIsEdit(false)
    setCardModal(true)
  }

  /* Add card code */
  const editCard = (index) => {
    setEditCardIndex(index)
    setSingleSlideData(slidesData[index])
    setIsEdit(true)
    setCardModal(true)
  }
  return (
    <>
      {cardModal && (
        <DefaultBannerCardModal
          cancelCardModal={(cardModal) => {
            setSingleSlideData({})
            setCardModal(false)
          }}
          singleSlideData={singleSlideData}
          setSingleSlideData={setSingleSlideData}
          editCardIndex={editCardIndex}
          slidesData={slidesData}
          setSlidesData={setSlidesData}
          isEdit={isEdit}
        />
      )}
      <CModal size="lg" className="" visible={true}>
        <CModalHeader
          style={{ borderBottom: 0 }}
          className="d-flex flex-column justify-content-center mt-3 px-5"
        >
          <p style={{ fontSize: '1.2rem' }}>
            <b style={{ fontWeight: '500' }}>Banner Carousel Editor</b>
          </p>
          <div
            style={{ fontSize: '1rem' }}
            className="d-flex justify-content-between w-100 px-1 -mb-4"
          >
            <h6>
              SLIDES <br />
              <span className="font-thin text-xs">Drag to Re-arrange</span>
            </h6>
            <div className="flex">
              <span style={{ fontSize: '13px' }} className="mr-2">
                Auto Slide
              </span>
              <CFormSwitch
                label=""
                value={autoSlide}
                checked={autoSlide}
                valid={autoSlide}
                id="buttonEnable"
                onChange={(e) => setAutoSlide(e.target.checked)}
              />
            </div>
          </div>
        </CModalHeader>
        <CModalBody
          scrollable
          style={{ height: '70vh' }}
          className=" static-scrollbar-class d-flex flex-column justify-content-between px-5 "
        >
          <div
            className="d-flex justify-content-center h-full flex-shrink-0"
            style={{ width: '100%', minHeight: '100%' }}
          >
            <div
              style={{
                width: '100%',
                height: '100%',
                overflowX: 'hidden',
                overflowY: 'auto',
              }}
              className="flex flex-column justify-content-start align-items-center p-2 -mt-3 bg-[#e9e9e9] rounded-md outline outline-1 outline-gray-400 scrollbar"
            >
              {/* <TemplateAccordion items={accordionItems} styles={''} /> */}
              <ReactDragListView {...dragProps}>
                <CTable
                  className="mt-1 w-full"
                  style={{
                    borderCollapse: 'separate',
                    borderSpacing: '0 13px',
                    tableLayout: 'fixed',
                  }}
                >
                  <CTableBody>
                    {!isEmpty(slidesData) ? (
                      slidesData.map((item, index) => {
                        let deleteDisabled = slidesData.length < 3
                        return (
                          <CTableRow
                            key={index}
                            className="overflow-hidden bg-[#fff] rounded outline outline-1 outline-gray-400 hover:outline-[#2172eb] hover:outline-2"
                            style={{
                              borderRadius: '10px',
                            }}
                          >
                            <CTableDataCell
                              style={{ width: '4%' }}
                              align="middle"
                              className="hover:cursor-move"
                            >
                              <img src={SixDots} alt="" />
                            </CTableDataCell>
                            <CTableDataCell style={{ width: '18%' }} align="middle">
                              <img
                                src={getThumbnail(
                                  userSessionObj?.session_data?.cf_domain_name,
                                  item.image_s3_key,
                                )}
                                alt=""
                                className="w-100"
                                // style={{ height: '56px', width: '107px' }}
                              />
                            </CTableDataCell>
                            <CTableDataCell
                              style={{ width: 'auto' }}
                              align="middle"
                            ></CTableDataCell>
                            <CTableDataCell
                              align="middle"
                              style={{ textAlign: 'center', width: '6%' }}
                            >
                              <div
                                className=" h-[32px] w-[32px] rounded-full bg-[#2172eb] flex justify-center items-center cursor-pointer shadow-2xl"
                                onClick={() => editCard(index)}
                                style={{ boxShadow: '2px 2px 4px 0 rgba(0, 0, 0, 0.3)' }}
                              >
                                <img src={EditIcon} className="w-[17px] h-[17px] " alt="editicon" />
                              </div>
                            </CTableDataCell>
                            <CTableDataCell
                              align="middle"
                              style={{ textAlign: 'center', width: '6%' }}
                            >
                              <div
                                className=" h-[32px] w-[32px] rounded-full bg-[#2172eb] flex justify-center items-center cursor-pointer shadow-2xl"
                                onClick={() => copyCard(index)}
                                style={{ boxShadow: '2px 2px 4px 0 rgba(0, 0, 0, 0.3)' }}
                              >
                                <img
                                  src={CopyLight}
                                  className="w-[17px] h-[17px] "
                                  alt="copyIcon"
                                />
                              </div>
                            </CTableDataCell>
                            <CTableDataCell
                              align="middle"
                              style={{ textAlign: 'center', width: '7%' }}
                            >
                              <div
                                className={`mr-4 h-[32px] w-[32px] rounded-full ${
                                  !deleteDisabled ? 'bg-[#2172eb]' : 'bg-[#7f817f]'
                                } flex justify-center items-center cursor-pointer shadow-2xl`}
                                onClick={deleteDisabled ? '' : () => deleteCard(index)}
                                style={{ boxShadow: '2px 2px 4px 0 rgba(0, 0, 0, 0.3)' }}
                                title={deleteDisabled ? 'Cannot be less than 2 items' : ''}
                              >
                                <img
                                  src={TrashIcon}
                                  className="w-[17px] h-[17px]"
                                  alt="trashicon"
                                />
                              </div>
                            </CTableDataCell>
                          </CTableRow>
                        )
                      })
                    ) : (
                      <CTableRow>
                        <CTableDataCell colSpan="6">
                          <p>No Banner Found</p>
                        </CTableDataCell>
                      </CTableRow>
                    )}
                  </CTableBody>
                </CTable>
              </ReactDragListView>
              <div
                className="overflow-hidden bg-[#fff] rounded outline outline-1 outline-gray-400 w-full flex flex-col justify-center items-center cursor-pointer flex-shrink-0 p-3 -mt-2 mb-2"
                style={{
                  borderRadius: '10px',
                }}
                onClick={() => addNewCard()}
              >
                <div
                  className="h-[24px] w-[24px] rounded-full bg-[#2172eb] flex justify-center items-center shadow"
                  style={{ boxShadow: '2px 2px 4px 0 rgba(0, 0, 0, 0.3)' }}
                >
                  <img src={PlusIcon} className="w-[15px] h-[15px]" alt="trashicon" />
                </div>
                <p className="text-sm font-medium mb-0">Add a new Slide</p>
              </div>
              {deleteModal && (
                <DeleteModal
                  openModal={deleteModal}
                  title={`Are you sure you want to delete this Banner ?`}
                  confirmButtonText={`Yes`}
                  onCancel={() => {
                    setSelectedCardIndex('')
                    setDeleteModal(false)
                  }}
                  onConfirm={() => onDeleteCard(selectedCardIndex)}
                />
              )}
            </div>
          </div>
        </CModalBody>
        <CModalFooter style={{ borderTop: 0 }} className="">
          <div style={{ marginRight: '5%' }} className="pb-3">
            <CButton
              style={{ color: 'black', border: '1px solid black', fontSize: '1.1rem' }}
              className="mx-4 bg-white rounded-1 btn-focus-none"
              onClick={onCancel}
            >
              Cancel
            </CButton>
            <CButton
              style={{ fontSize: '1.1rem' }}
              className=" bg-black rounded-1 btn-focus-none px-3"
              onClick={handleSave}
            >
              Save
            </CButton>
          </div>
        </CModalFooter>
      </CModal>
    </>
  )
}

export default DefaultBannerModal
